<template>
    <b-modal :active.sync="isModalActive" has-modal-card>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">
            <b>Desligar {{ item?.nome }}</b>
          </p>
          <button type="button" class="delete" @click="cancel" />
        </header>
        <section class="modal-card-body">

          <form @submit.prevent="buscar" class="columns is-centered">

              <b-field label="Data Desligamento">
                  <b-input type="date" v-model="date" icon="email-outline" placeholder="E-mail*" name="email" required/>
              </b-field>
            </form>

        </section>
        <footer class="modal-card-foot">
          <b-button native-type="button" type="is-danger" outlined @click="cancel">
            Cancelar
          </b-button>
          <b-button type="is-success" @click="confirm">
            Salvar
          </b-button>
        </footer>
      </div>
    </b-modal>
  </template>
    
  <script>
  import { defineComponent } from 'vue'
  import PessoaService from '@/services/PessoaService';

  export default defineComponent({
    name: 'ModalDesligarPessoa',
    props: {
      isActive: Boolean,
      item: Object
    },
    emits: ['cancel', 'confirm'],
    data() {
      return {
          date: null
      }
    },
    computed: {
      isModalActive: {
        get: function () {
          return this.isActive
        },
        set: function (value) {
          if (!value) {
            this.cancel()
          }
        }
      }
    },
    methods: {
      confirm() {
      this.$emit('confirm', this.date)
    },
  
      cancel() {
        this.$emit('cancel')
      }
    }
  })
  </script>
    